var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGForcedLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95455 17.7778L6.81818 20L3.40909 17.7778L0 15.5556L5.68182 13.3333L2.27273 5.55556L9.09091 8.88889L12.5 0L15.9091 8.88889L22.7273 5.55556L19.3182 13.3333L25 15.5556L18.1818 20L17.0455 17.7778L20.4545 15.5556L17.0455 14.4444L19.3182 8.88889L14.7727 11.1111L12.5 4.44444L10.2273 11.1111L5.68182 8.88889L7.95455 14.4444L4.54545 15.5556L7.95455 17.7778Z",
    fill: "#B11500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7727 17.7778L15.9091 18.8889L14 20H11L9.09091 18.8889L10.2273 17.7778L7.95455 15.5556H10.2273L9.09091 12.2222L11.3636 14.4444L12.5 10L13.6364 14.4444L15.9091 12.2222L14.7727 15.5556H17.0455L14.7727 17.7778Z",
    fill: "#B11500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGForcedLegend);
export default __webpack_public_path__ + "static/media/gForced-legend.8149734cf1149c91914320eb3fe4ad07.svg";
export { ForwardRef as ReactComponent };